export type AppNotification = EditorNotSupportedNotification;

export enum AppNotificationType {
  EditorNotSupported,
}

interface EditorNotSupportedNotification {
  type: AppNotificationType.EditorNotSupported;
  data: {
    appName: string;
    editorType: 'EDITORX' | 'STUDIO';
  };
}
